import LotusMark from './LotusMark.jsx';
import ResponsiveImage from './ResponsiveImage.jsx';

export default function PageHero({ title, intro, label, image, imageAlt = '', dark = false, children }) {
  return (
    <section className={`page-hero ${dark ? 'page-hero--dark' : ''} ${image ? 'page-hero--with-media' : 'page-hero--text-only'}`}>
      <div className="page-hero__content shell">
        <div className="page-hero__copy reveal">
          {label ? <p className="page-hero__label">{label}</p> : null}
          <LotusMark className="page-hero__mark" />
          <h1>{title}</h1>
          <p className="page-hero__intro">{intro}</p>
          {children}
        </div>
        {image ? (
          <figure className="page-hero__media reveal reveal--delay">
            <ResponsiveImage src={image} alt={imageAlt} eager sizes="(max-width: 900px) 100vw, 46vw" />
          </figure>
        ) : null}
      </div>
    </section>
  );
}
